/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */

// initial state
import api, { apiInternal } from '../../api.js';
import {getAuthToken, getUser, setAuthToken, setLoggedUser} from '../../storage.js'
const state = {
  status: '',
  token: getAuthToken(),
  user: getUser()
};

// getters
const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  role: state => state.user.access_type,
  user: state => state.user,
};

// actions
const actions = {
  async login({ commit }, user) {
    const result = await api.post(`${apiInternal}/login`, user);
    if (result) {
      commit("setUserLogged", result.data);
      commit("setAuthToken", result.headers["x-auth-token"]);
    }
    else {
      commit('logout');
    }
    return result;
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout');
      resolve();
    });
  },
};

// mutations
const mutations = {
  setAuthToken(data, token) {
    setAuthToken(token);
    data.token = token;
    data.status = 'success';
  },
  setUserLogged(data, user) {
    setLoggedUser(user);
    data.user = user;
  },
  auth_request(data) {
    data.status = 'loading';
  },

  logout(data) {
    data.status = '';
    data.token = '';
    data.user = {};
    setAuthToken('');
    setLoggedUser({});
  },
  initialiseStore(data) {
    const v =  getAuthToken();
    if (v && v !== 'undefined') {
      data.user = getUser();
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
